define('casino/search',['jquery', 'casino/casino', 'casino/casino-data', 'all/scroller'], function($, casino, casinoData) {
	'use strict';

	// TODO: javascript - remove global casino.search and setup callbacks from an init() method

	function searchGames(searchPattern) {
		var gameIds = [];
		var regExp = new RegExp(searchPattern, 'i');

		$.each(casinoData.games, function(gameId, game) {
			if (regExp.test(game.name) || regExp.test(game.shortDescription)) {
				gameIds.push(gameId);
			}
		});
		return gameIds;
	}

	function init($searchField) {
		$searchField.val($searchField.data('default'));
		$searchField.focus(function() {
			var $this = $(this);
			if ($this.val() === $this.data('default')) {
				$this.val('');
			}
		});

		$searchField.focusout(function() {
			var $this = $(this);
			if ($this.val() === '') {
				$this.val($this.data('default'));
			}
		});
	}

	window.casino = {
		search: {
			games: function($searchField, $resultHolder, options) {
				var searchValue = $searchField.val();
				var numberOfGames = 0;
				if (searchValue.length > 2) {
					var lastIds = $resultHolder.data('lastIds');
					var gameIds = searchGames(searchValue);
					numberOfGames = gameIds.length;
					var saveIds = gameIds.join(',');
					if (saveIds !== lastIds) {
						if (options.gamesPerPage !== 0) {
							$resultHolder.scrollerStop();
						}
						$resultHolder.populate(gameIds, options);
						if (options.gamesPerPage !== 0) {
							$resultHolder.scroller({direction: 'left', auto: false});
						}
						$resultHolder.data('lastIds', saveIds);
					}

					var $searchSpan = $resultHolder.find('h1 span');
					if (gameIds.length === 0) {
						$searchSpan.text($searchField.data('noResult'));
						$searchSpan.show();
					} else {
						$searchSpan.hide();
					}
					$resultHolder.show();
				} else {
					if (options.hasStarted) {
						$resultHolder.find('h1 span').text($searchField.data('noResult'));
					} else {
						$resultHolder.hide();
					}
				}
				return numberOfGames;
			},
			clear: function($searchField, $resultHolder) {
				$searchField.val($searchField.data('default'));
				$resultHolder.hide();
			},
			init: init
		}
	};

	$(function() {
		init($('#casino-gamesearch'));
		$('#gamesearch').keyup(function() {
			window.casino.search.games($('#casino-gamesearch'), $('#searchresults'), {});
		});
	});

	return window.casino.search;
});

